import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
} from "@angular/core";
import {
  Router,
  NavigationStart,
  RouterLink,
  RouterLinkActive,
  PRIMARY_OUTLET,
} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {Subscription} from "rxjs";
import {User} from "src/app/modules/auth/models/User";
import {ModalService} from "src/app/modules/core/services/modal.service";
import {MOBILE_EXPLORER_NAV_ITEMS} from "../navigation/navigation-items.constants";

@Component({
  selector: "app-my-works-nav",
  templateUrl: "./my-works-nav.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, TranslateModule],
})
export class MyWorksNavComponent implements OnDestroy {
  @Input() user?: User;
  public readonly navigationItems = MOBILE_EXPLORER_NAV_ITEMS;
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly router: Router,
    private readonly modalService: ModalService
  ) {
    const routeSubscription = this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationStart)) return;
      const destination = this.router.parseUrl(event.url).root.children[
        PRIMARY_OUTLET
      ];
      if (destination?.segments[0]?.path !== "search") {
        this.modalService.closeModal();
      }
    });
    this.subscriptions.push(routeSubscription);
  }

  public onLinkClick(): void {
    this.modalService.closeModal();
  }

  onKeyUp(event: KeyboardEvent, type: string): void {
    if (event.key === "Enter" || event.key === " ") {
      if (type === "onLinkClick") {
        this.onLinkClick();
      }
    }
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
